import React from 'react';
import {Control} from "react-redux-form";
import {Creatable} from "react-select";
import {tags} from "../../ducks";
import duckify from "../../utils/duckify";

/**
 * Component for adding/editing snippet tags. This component is meant for use as a custom control for a field
 * passed to <SnippetEditor/> and <SnippetAttributes/> with the `fields` prop.
 */
const TagControl = ({tags, ...props}) => {
  return <Control.select
    component={Creatable}
    mapProps={{
      onChange: ({onChange}) => (selected) => onChange((selected || []).map((s) => s.value)),
      value: ({modelValue}) => (modelValue || []).map((mv) => ({value: mv, label: mv}))
    }}
    multi
    options={tags.map(t => ({value: t.name, label: t.name}))}
    {...props}
  />
};

const mapDucksToPros = () => ({tags});

export default duckify(mapDucksToPros)(TagControl);